import React, { useState, useEffect } from "react";
import GroupCard from "./GroupCard";
import "./GroupStructureSection.css";
import { motion, useAnimation } from "framer-motion";

const cards = [
    {
    image: require("../../Assets/about/buildergroup.jpg"),
    title: "Construction",
    desc: "Building enduring infrastructure that stands the test of time.",
    paragraph: "From civil projects to public spaces, VCNR Construction brings scale, strength, and sustainability to everything it builds.",
    icon: require("../../Assets/about/whitelogo.png"),
  },

  {
    image: require("../../Assets/about/healthcaregroup.png"),
    title: "Healthcare",
    desc: "Delivering accessible, quality care where it matters most.",
    paragraph: "We create inclusive healthcare ecosystems designed especially for underserved and underprivileged communities.",
    icon: require("../../Assets/about/whitelogo.png"),
  }, 
  {
    image: require("../../Assets/about/technologygroup.jpg"),
    title: "Technologies",
    desc: "Driving transformation through AI, software, and next-gen R&D.",
    paragraph: "Our technology platforms deliver future-ready solutions across industries, pushing the boundaries of digital innovation.",
    icon: require("../../Assets/about/whitelogo.png"),
  },
   {
    image: require("../../Assets/about/goldgroup.jpg"),
    title: "Gold and Diamond",
    desc: "Blending timeless tradition with new-age luxury.",
    paragraph: "Our retail experience combines craftsmanship, trust, and contemporary design—where heritage meets aspiration.",
    icon: require("../../Assets/about/whitelogo.png"),
  },
  {
    image: require("../../Assets/about/foundationgroup.jpg"),
    title: "Educational Trust",
    desc: "VCNR Education Trust believes education is the cornerstone of societal progress. ",
    paragraph: "By combining foundational learning with professional skill development, we aim to create a generation capable of driving positive change in every community they touch.",
    icon: require("../../Assets/about/whitelogo.png"),
  },
  {
    image: require("../../Assets/about/buildergroup.jpg"),
    title: "Properties",
    desc: "Creating sustainable and innovative spaces that enrich communities and lives.",
    paragraph: "VCNR Properties creates sustainable and innovative spaces that enrich communities and lives.",
    icon: require("../../Assets/about/whitelogo.png"),
  },
  {
    image: require("../../Assets/about/mallgroup.jpg"),
    title: "Hospitality",
    desc: "Soul-soothing resorts and retreats designed for relaxation and reconnection.",
    paragraph: "Come to relax and reconnect with your loved ones, or celebrate a milestone. More than just a stay, We offer soul-soothing experiences.",
    icon: require("../../Assets/about/whitelogo.png"),
  },
  {
    image: require("../../Assets/about/agrotechgroup.jpg"),
    title: "Agrotech",
    desc: "Empowering farmers with smart tech and sustainable tools.",
    paragraph: "We’re bringing AI to the soil—through modern equipment, scalable practices, and data-led agricultural transformation.",
    icon: require("../../Assets/about/whitelogo.png"),
  },
  
  {
    image: require("../../Assets/about/foundationgroup.jpg"),
    title: "Hitachinthana Trust",
    desc: "Encouraging education, health, and social welfare through charitable initiatives.",
    icon: require("../../Assets/about/whitelogo.png"),
  },
  // {
  //   image: require("../../Assets/about/aerospacegroup.jpg"),
  //   title: "Aerospace & Manufacturing",
  //   desc: "Emerging innovations in aviation and advanced engineering.",
  //   icon: require("../../Assets/about/whitelogo.png"),
  // },
  // {
  //   image: require("../../Assets/about/mallgroup.jpg"),
  //   title: "MALL (UPCOMING)",
  //   desc: "A landmark retail and entertainment destination for Karnataka.",
  //   paragraph: "More than just a mall—an experience hub designed for community, culture, and commerce.",
  //   icon: require("../../Assets/about/whitelogo.png"),
  // },
];

export default function GroupStructureSection() {
  const leftCards = cards.filter((_, i) => i % 2 === 1);
  const rightCards = cards.filter((_, i) => i % 2 === 0);

  const cardHeight = 800;
  const visibleCards = 4;

  const [isPaused, setIsPaused] = useState(false);
  const leftControls = useAnimation();
  const rightControls = useAnimation();

  const leftTotalHeight = leftCards.length * cardHeight;
  const rightTotalHeight = rightCards.length * cardHeight;
  const duration = 10 * leftCards.length;

  // Detect mobile view
const [isMobile, setIsMobile] = useState(false);

useEffect(() => {
  const checkMobile = () => setIsMobile(window.innerWidth <= 768);
  checkMobile(); // Initial check
  window.addEventListener("resize", checkMobile);
  return () => window.removeEventListener("resize", checkMobile);
}, []);



useEffect(() => {
  if (isMobile) {
    leftControls.stop();
    rightControls.stop();
    return;
  }

  if (!isPaused) {
    // Left column scrolls upward
    leftControls.start({
      y: [0, -leftTotalHeight],
      transition: {
        duration,
        ease: "linear",
        repeat: Infinity,
      },
    });

    // Right column scrolls downward (reverse + delay for zigzag)
    rightControls.start({
      y: [-rightTotalHeight, 0],
      transition: {
        duration,
        ease: "linear",
        repeat: Infinity,
        delay: duration / 2, // creates natural offset between columns
      },
    });
  } else {
    leftControls.stop();
    rightControls.stop();
  }
}, [isPaused, isMobile, leftControls, rightControls, leftTotalHeight, rightTotalHeight, duration]);




  return (
    <section className="group-structure-zigzag">
      {/* LEFT */}
      <div className="group-structure-zigzag-left">
        <div className="group-structure-zigzag-heading">
          <h2>
            Our Group <br /> Structure
          </h2>
          <div className="group-structure-sub">
            VCNR: One Brand. Infinite Possibilities.
          </div>
          <p>At VCNR, we don’t just pick industries, we grow them from the ground up. Every venture starts with a problem we genuinely care about solving, something we first build for ourselves before sharing it with the world. We developed software to streamline our construction projects, and it blossomed into a thriving technology business. We built tools to support our hospitals, and they evolved into a full-fledged healthcare ecosystem. Every VCNR story begins with a real need, shaped into a real solution, and driven by an unwavering passion to create lasting value.</p>
        </div>
        <div
          className="scrolling-cards"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          style={{
            position: "relative",
            height: cardHeight * visibleCards,
            overflow: "hidden",
          }}
        >
          <motion.div
            animate={leftControls}
            style={{
              display: "flex",
              flexDirection: "column",
              willChange: "transform",
            }}
          >
            {[...leftCards, ...leftCards].map((card, i) => (
              <div
                key={i}
                className="group-structure-zigzag-card"
                style={{ height: cardHeight }}
              >
                <GroupCard {...card} />
              </div>
            ))}
          </motion.div>
        </div>
        <div className="text-left">
          <p>
Each vertical operates independently, but shares a unified commitment to VCNR’s vision—of purposeful growth, human progress, and a better tomorrow.          </p>
          <button className="explore-btn">Explore Our Verticals</button>
        </div>
      </div>

      {/* CENTER */}
      <div className="group-structure-zigzag-middle">
        <div className="group-structure-zigzag-vertical-line">
          <div className="group-structure-zigzag-circle" />
        </div>
      </div>

      {/* RIGHT */}
      <div className="group-structure-zigzag-right">
        <div
          className="scrolling-cards"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          style={{
            position: "relative",
            height: cardHeight * visibleCards,
            overflow: "hidden",
          }}
        >
          <motion.div
            animate={rightControls}
            style={{
              display: "flex",
              flexDirection: "column",
              willChange: "transform",
            }}
          >
            {[...rightCards, ...rightCards].map((card, i) => (
  <div
    key={i}
    className="group-structure-zigzag-card"
    style={{ height: cardHeight }}
  >
    <GroupCard {...card} />
  </div>
))}


          </motion.div>
        </div>
      </div>
    </section>
  );
}
